import { BaseIconButton, type BaseIconButtonProps } from "../BaseIconButton";
import { CbhIcon, type IconType } from "../CbhIcon";

export interface IconButtonProps extends Omit<BaseIconButtonProps, "children"> {
  iconType: IconType;
}
/**
 * A wrapper around MuiIconButton that limits variants to our custom ones and adds our custom icon
 * handling.
 *
 * NOTE: Provide `href` to make the button render as an anchor tag. It will support react-router
 * redirects.
 */
export function IconButton(props: IconButtonProps) {
  const { iconType, ...restProps } = props;

  return (
    <BaseIconButton {...restProps}>
      <CbhIcon type={iconType} />
    </BaseIconButton>
  );
}
